<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Payee Routee</div>
        <div>
          <bread-crumb :bread-crumbs="['Payee Route']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-tabs v-model="usertype">
        <v-tab
          v-for="item in items"
          :key="item.key"
          :href="'#' + item.key"
          class="text-capitalize text-decoration-none"
        >
          {{ item.label }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="usertype">
        <v-tab-item id="country">
          <Countrywise />
        </v-tab-item>
        <v-tab-item id="partner">
          <SendPartnerwise />
        </v-tab-item>
        <v-tab-item id="bank">
          <BankPartnerwise />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
import Countrywise from "./payrouteetabs/PayeeRouteCountrywise.vue";
import SendPartnerwise from "./payrouteetabs/Payroutesendpartnerwise.vue";
import BankPartnerwise from "./payrouteetabs/payeeRouteBankwise.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Payee Route",
  data: () => {
    return {
      usertype: "Induvisual",
      items: [
        { label: "Country Wise", key: "country" },
        { label: "Partner Wise", key: "partner" },
        { label: "Bank Wise", key: "bank" },
      ],
    };
  },
  components: {
    BreadCrumb,
    Countrywise,
    SendPartnerwise,
    BankPartnerwise,
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
